import React from 'react';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';
import CenteredLoader from '@eika-kortbetjening/state-handling-modal/lib/loader/Loader';
import { ErrorMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import {
    GooglePayAlreadyActivatedMessage,
    GooglePayData,
    useGoogleDigitalCardTokenStatus,
} from '@domain/digital-wallet';
import { CreditCardTokenStatus, DigitalWalletTokenStatus } from '@generated-types';

import { AddToGooglePay } from './add-to-google-pay/AddToGooglePay';

import './GooglePayActivationStatusAndOnboardingControl.scss';

interface GooglePayActivationStatusAndOnboardingControlProps {
    data: GooglePayData;
    googleWalletInfo: GtpWalletInfoResult;
    startGooglePayActivationWithSigning: () => void;
}

interface TokenizationInvalidErrorProps {
    tokenizationError: string;
}

const TokenizationInvalidError = ({ tokenizationError }: TokenizationInvalidErrorProps) => (
    <ErrorMessage text={tokenizationError} icon={IconTypes.LUKK_24} />
);

export const GooglePayActivationStatusAndOnboardingControl = ({
    data,
    googleWalletInfo,
    startGooglePayActivationWithSigning,
}: GooglePayActivationStatusAndOnboardingControlProps) => {
    const { currentStatus, tokenizationError } = useGoogleDigitalCardTokenStatus(data);

    if (currentStatus === 'REGISTERED') {
        if (data.source === 'te' && data.digitalCard?.status === DigitalWalletTokenStatus.ACTIVE) {
            return <GooglePayAlreadyActivatedMessage />;
        }
        if (data.source === 'kb') {
            const token = data.elibigleCard.tokens.find((token) => token.status === CreditCardTokenStatus.ACTIVE);
            if (token) {
                return <GooglePayAlreadyActivatedMessage />;
            }
        }
    }

    if (currentStatus === 'INIT') {
        return <CenteredLoader />;
    }

    if (currentStatus === 'UNREGISTERED') {
        return (
            <>
                {tokenizationError && <TokenizationInvalidError tokenizationError={tokenizationError} />}
                <AddToGooglePay
                    data={data}
                    googleWalletInfo={googleWalletInfo}
                    startGooglePayActivationWithSigning={startGooglePayActivationWithSigning}
                />
            </>
        );
    }

    return null;
};
